import { useEffect, useState } from "react";
import { toast } from "sonner";
import { errMsg, useApi } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Empty } from "./helpers";

function Group({ g, i, onMerge }) {
  const [primary, setPrimary] = useState(g.contacts[0].id);
  return (
    <div className="space-y-2 rounded-lg border border-slate-200 p-3" data-testid={`dup-group-${i}`}>
      <p className="text-xs font-semibold text-slate-700">Stesso {g.reasons.join(" / ")} · scegli il contatto principale</p>
      {g.contacts.map((c) => (
        <label key={c.id} className="flex items-start gap-2 text-xs" data-testid={`dup-contact-${c.id}`}>
          <input type="radio" name={`p-${i}`} checked={primary === c.id} onChange={() => setPrimary(c.id)} className="mt-0.5" data-testid={`dup-primary-${c.id}`} />
          <span className="min-w-0"><b className="text-slate-800">{c.name}</b> <span className="text-slate-500">{[c.email, c.phone, c.vat, c.company].filter(Boolean).join(" · ")}</span></span>
        </label>))}
      <Button size="sm" onClick={() => onMerge(primary, g.contacts.filter((c) => c.id !== primary).map((c) => c.id))} data-testid={`dup-merge-${i}`}>Unisci nel principale</Button>
    </div>
  );
}

export default function DuplicatesDialog({ tid, onClose, onDone }) {
  const api = useApi();
  const [groups, setGroups] = useState(null);
  const load = () => api.get(`/t/${tid}/crm/duplicates`).then(({ data }) => setGroups(data)).catch((e) => { setGroups([]); toast.error(errMsg(e)); });
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const merge = async (primary_id, duplicate_ids) => {
    try { await api.post(`/t/${tid}/crm/contacts/merge`, { primary_id, duplicate_ids }); toast.success("Contatti uniti: i duplicati sono nel cestino"); load(); onDone(); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92vh] overflow-y-auto sm:max-w-2xl" data-testid="duplicates-dialog">
        <DialogHeader><DialogTitle>Contatti duplicati</DialogTitle></DialogHeader>
        <p className="text-xs text-slate-500">Confronto per email, telefono e partita IVA. Il principale tiene i suoi dati e riceve solo i campi vuoti, storico, opportunità e attività.</p>
        {groups === null ? <p className="text-sm text-slate-500">Caricamento…</p> : !groups.length ? <Empty testid="duplicates-empty">Nessun duplicato trovato.</Empty> :
          <div className="space-y-3">{groups.map((g, i) => <Group key={g.contacts.map((c) => c.id).join()} g={g} i={i} onMerge={merge} />)}</div>}
      </DialogContent>
    </Dialog>
  );
}
